// ===== Descrição automática =====
function gerarDescricaoAutomatica(){
  const materiais=[...new Set(_pedItens.map(item=>String(item.material||'').trim()).filter(Boolean))];
  const ambientes=[...new Set([
    ..._pedAmbList.map(ambiente=>String(typeof ambiente==='string'?ambiente:ambiente.nome||'').trim()),
    ..._pedItens.map(item=>String(item.ambiente||'').trim())
  ].filter(Boolean))];
  if(!materiais.length&&!ambientes.length){
    // Ainda sem peças lançadas (ex.: orçamento recém-convertido de um lead) —
    // usa o interesse declarado no lead para não deixar a descrição vazia.
    const leadId=document.getElementById('p-lead-id')?.value;
    const lead=leadId?(CACHE.leads||[]).find(l=>l.id===leadId):null;
    if(lead&&((lead.pedras||[]).length||(lead.ambientes||[]).length)){
      return [
        (lead.pedras||[]).length?`Interesse: ${lead.pedras.join(', ')}`:'',
        (lead.ambientes||[]).length?`Ambientes: ${lead.ambientes.join(', ')}`:''
      ].filter(Boolean).join('\n');
    }
  }
  return [
    materiais.length?`Interesse: ${materiais.join(', ')}`:'',
    ambientes.length?`Ambientes: ${ambientes.join(', ')}`:''
  ].filter(Boolean).join('\n');
}
function exibirAtualizarDescricao(mostrar){
  const link=document.getElementById('p-desc-auto-link');
  if(link)link.style.display=mostrar?'':'none';
}
function atualizarDescricaoAutomatica(opts){
  opts=opts||{};
  const forcar=!!opts.forcar;
  const textarea=document.getElementById('p-desc');
  if(!textarea)return;
  bindPedDescListener();
  const novaDescricao=gerarDescricaoAutomatica();
  const valorAtual=textarea.value.trim();
  const podeAtualizar=forcar||!valorAtual||(!_pedDescManual&&valorAtual===_pedDescAutoLast.trim());
  if(!podeAtualizar){exibirAtualizarDescricao(true);return;}
  textarea.value=novaDescricao;
  _pedDescAutoLast=novaDescricao;
  _pedDescManual=false;
  exibirAtualizarDescricao(false);
}
function inicializarDescricaoAutomatica(descricaoSalva){
  descricaoSalva=descricaoSalva||'';
  const descricaoEsperada=gerarDescricaoAutomatica();
  _pedDescAutoLast=descricaoEsperada;
  _pedDescManual=Boolean(descricaoSalva.trim())&&descricaoSalva.trim()!==descricaoEsperada.trim();
  exibirAtualizarDescricao(_pedDescManual);
  bindPedDescListener();
}
function bindPedDescListener(){
  if(_pedDescListenerBound)return;
  const textarea=document.getElementById('p-desc');
  if(!textarea)return;
  textarea.addEventListener('input',event=>{
    _pedDescManual=event.target.value.trim()!==_pedDescAutoLast.trim();
    exibirAtualizarDescricao(_pedDescManual);
  });
  _pedDescListenerBound=true;
}

